module.exports = "/assets/success-eggs-rw.png?txeT6LR";